<template>
  <!-- 心理辅导详情 -->
  <div>
    <!-- 新版初次访谈报告    2022-02-10日期为界 -->
    <div
      class="newFirstCoachReport"
      v-if="checkedRecord.record && checkedRecord.record.isNew"
    >
      <div
        style="width: 100%"
        v-if="
          checkedRecord &&
          checkedRecord.studentInfo &&
          checkedRecord.all
        "
      >
        <table class="student-show" valign="middle">
          <tr align="center" class="table-header">
            <td colspan="5">中小学生心理健康访谈记录表</td>
          </tr>
          <!-- 基本信息 -->
          <tr align="left">
            <td class="set-padding">
              姓名：{{
                checkedRecord.studentInfo.name
                  ? checkedRecord.studentInfo.name
                  : checkedRecord.studentInfo.outsider_name
              }}
            </td>
            <td colspan="2" class="set-padding">
              身份证：{{ checkedRecord.studentInfo.idcard }}
            </td>

            <td class="set-padding">
              性别：{{ $LYCom.getSexName(checkedRecord.studentInfo.sex) }}
            </td>
            <td class="set-padding">
              年龄：{{ checkedRecord.studentInfo.age }}
            </td>
          </tr>
          <tr align="left" v-if="checkedRecord.studentInfo.studentId">
            <td class="set-padding">
              生日：{{
                $LYCom.GetBirthdayByIdCard(checkedRecord.studentInfo.idcard)
              }}
            </td>

            <td colspan="2" class="set-padding">
              <span v-if="checkedRecord.studentInfo.schoolName"
                >学校名称：{{ checkedRecord.studentInfo.schoolName }}</span
              >
            </td>
            <td colspan="2" class="set-padding">
              <span v-if="checkedRecord.studentInfo.className">
                班级：{{ checkedRecord.studentInfo.className }}</span
              >
            </td>
          </tr>
      
          <template v-for="(questions, index) in checkedRecord.all">
             <!-- 家庭情况 -->
          <tr v-for="(item, i) in questions" :key="item.questionId">
            <td :rowspan="questions.length" v-if="i == 0">
              {{item.categoryName}}
            </td>
            <td>{{ item.description }}</td>
            <td colspan="3" align="left" class="set-padding">
              <!-- 多选答案 -->
              <div class="flex questBox" v-if="item.type == 1">
                <div
                  class="check-box"
                  v-for="subItem in item.options"
                  :key="subItem.optionId"
                >
                  <img
                    src="/static/images/ischecked.png"
                    v-if="
                      item.checkOptionIds &&
                      item.checkOptionIds.find(
                        (item) => item == subItem.optionId
                      )
                    "
                    class="el-icon-check isChecked check-icon"
                    alt=""
                  />

                  <span class="check-icon noChecked" v-else></span>
                  <span class="check-text">{{ subItem.description }}</span>
                </div>
              </div>
              <!-- 单选答案 -->
              <div class="flex questBox" v-else-if="item.type == 2">
                <div
                  class="check-box"
                  v-for="subItem in item.options"
                  :key="subItem.optionId"
                >
                  <i
                    class="el-icon-success check-icon"
                    v-if="item.checkOptionId == subItem.optionId"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">{{ subItem.description }}</span>
                </div>
              </div>
              <!-- 填空答案 -->
              <div v-else class="flex questBox">
                <div   v-if="item.options && item.options.length">
                 <div
                  class="check-box"
                  v-for="subItem in item.options"
                  :key="subItem.optionId"
                >
                  {{ subItem.description }}：<span class="check-text">{{
                    subItem.value
                  }}</span>
                </div>
                </div>
                
                <div
                 v-else
                  class="check-box" >
                 <span class="check-text">{{
                    item.value
                  }}</span>
                </div>
              </div>
            </td>
          </tr>
          </template>
          <tr align="left" v-if="checkedRecord.record.type != 3">
            <td colspan="5" class="set-padding">
              <span v-if="checkedRecord.record.type == 1">抑郁情况分析：</span>
              <span v-if="checkedRecord.record.type == 2">焦虑情况分析：</span>
            </td>
          </tr>
          <tr align="left" v-if="checkedRecord.record.type != 3">
            <td colspan="5">
              <div style="min-height: 100px" v-if="depressedArr.length">
                <div
                  v-for="(item, index) in depressedArr"
                  :key="index"
                  :id="item.id"
                  :style="'width:100%;height:300px;'"
                ></div>
              </div>
            </td>
          </tr>

          <tr align="left">
            <td colspan="5" class="set-padding">特殊信息:</td>
          </tr>
          <tr>
            <td>就医史</td>

            <td colspan="2" align="left" class="set-padding">
              <div class="flex">
                <div class="margin-right">精神科:</div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="
                      checkedRecord.interviewReport.psychiatryDepartment == 1
                    "
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">有</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="
                      checkedRecord.interviewReport.psychiatryDepartment == 0
                    "
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">无</span>
                </div>
                <div class="margin-right">心理科:</div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="
                      checkedRecord.interviewReport.psychologyDepartment == 1
                    "
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">有</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="
                      checkedRecord.interviewReport.psychologyDepartment == 0
                    "
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">无</span>
                </div>
              </div>
            </td>

            <td colspan="2">
              {{ checkedRecord.interviewReport.psychiatryDescription }}
            </td>
          </tr>
          <tr>
            <td>服药史</td>

            <td colspan="2" align="left" class="set-padding">
              <div class="flex">
                <div class="margin-right">服药记录:</div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.medicineRecord == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">有</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.medicineRecord == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">无</span>
                </div>
              </div>
            </td>

            <td colspan="2">
              {{ checkedRecord.interviewReport.medicineDescription }}
            </td>
          </tr>

          <tr>
            <td>自伤自残史</td>

            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="margin-right">自伤:</div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.autolesion == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">有</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.autolesion == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">无</span>
                </div>

                <div class="margin-right">自残:</div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.autotomy == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">有</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.autotomy == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">无</span>
                </div>

                <div class="margin-right">自杀:</div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.suicide == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">有</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.suicide == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">无</span>
                </div>
              </div>
            </td>

            <td>
              {{
                checkedRecord.interviewReport.maimDescription
              }} 
            </td>
          </tr>

          <tr align="left">
            <td colspan="5" class="set-padding">结论：</td>
          </tr>
          <tr align="left">
            <td colspan="5">
              <div style="min-height: 50px" class="depressed_suggestion">
                <p>【基本情况】： {{ checkedRecord.record.conclusion }}</p>
                <p
                  v-if="
                    checkedRecord.record.type != 3 &&
                    depressedObj.conclusion.length
                  "
                >
                  【{{
                    checkedRecord.record.type == 1 ? "抑郁" : "焦虑"
                  }}情况】：
                  <span
                    v-for="(item, index) in depressedObj.conclusion"
                    :key="index"
                  >
                    {{ item }};
                  </span>
                </p>
              </div>
            </td>
          </tr>
          <tr align="left" v-if="checkedRecord.record.special">
            <td colspan="5" class="set-padding">特殊信息：</td>
          </tr>
          <tr align="left" v-if="checkedRecord.record.special">
            <td colspan="5" class="set-padding">
              <p class="conclusion_text">
                {{ checkedRecord.record.special }}
              </p>
            </td>
          </tr>
          <tr align="left">
            <td colspan="5" class="set-padding">
              严重程度：{{ $LYCom.GetDegreeName(checkedRecord.record.degree) }}
            </td>
          </tr>
          <!-- 结语 -->
          <tr align="left">
            <td colspan="5" class="set-padding">辅导记录及建议：</td>
          </tr>
          <tr align="left">
            <td colspan="5" class="set-padding">
              <p class="conclusion_text">
                {{ checkedRecord.record.epilogue }}
              </p>
            </td>
          </tr>
          <!-- 访谈表3特有信息 -->
          <template v-if="checkedRecord.record.isNew==3">
           <tr align="left">
            <td colspan="5" class="set-padding">问题形成原因：</td>
          </tr>
          <tr align="left">
            <td colspan="5" class="set-padding">
              <p class="conclusion_text">
                {{ checkedRecord.record.questionCause }}
              </p>
            </td>
          </tr>
          <tr align="left">
            <td colspan="5" class="set-padding">问题评估研判：</td>
          </tr>
          <tr align="left">
            <td colspan="5" class="set-padding">
              <p class="conclusion_text">
                {{ checkedRecord.record.questionAssessment }}
              </p>
            </td>
          </tr>
          <tr align="left">
            <td colspan="5" class="set-padding">危机应对措施：</td>
          </tr>
          <tr align="left">
            <td colspan="5" class="set-padding">
              <p class="conclusion_text">
                {{ checkedRecord.record.crisisMeasure }}
              </p>
            </td>
          </tr>
          </template>
        </table>
        <div class="create_user_name">
          <div class="teacher-style" style="margin: 5px 0">
            <span>心理老师</span>：{{ checkedRecord.record.createUserName }}
          </div>
          <div class="teacher-style">
            {{
              new Date(checkedRecord.record.createTime).format(
                "yyyy-MM-dd hh:mm:ss"
              )
            }}
          </div>
        </div>
      </div>
    </div>
    <!-- 旧版初次访谈报告 -->
    <div class="oldCoachReport" v-else>
      <div style="width: 100%">
        <table class="student-show" valign="middle" v-if="checkedRecord">
          <tr align="center" class="table-header">
            <td colspan="5">中小学生心理健康访谈记录表</td>
          </tr>
          <tr align="left">
            <td class="set-padding">
              姓名：{{
                checkedRecord.studentInfo.name
                  ? checkedRecord.studentInfo.name
                  : checkedRecord.studentInfo.outsider_name
              }}
            </td>
            <td colspan="2" class="set-padding">
              身份证：{{ checkedRecord.studentInfo.idcard }}
            </td>

            <td class="set-padding">
              性别：{{ $LYCom.getSexName(checkedRecord.studentInfo.sex) }}
            </td>
            <td class="set-padding">
              年龄：{{ checkedRecord.studentInfo.age }}
            </td>
          </tr>
          <tr align="left">
            <td class="set-padding">
              生日：{{
                $LYCom.GetBirthdayByIdCard(checkedRecord.studentInfo.idcard)
              }}
            </td>

            <td colspan="2" class="set-padding">
              学校名称：{{ checkedRecord.studentInfo.schoolName }}
            </td>
            <td colspan="2" class="set-padding">
              班级：{{ checkedRecord.studentInfo.className }}
            </td>
          </tr>
          <!-- 家庭情况 -->
          <tr>
            <td rowspan="9">家庭情况</td>
            <td>父母健康状况</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.parentHealth == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">健康</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.parentHealth == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">不健康</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.parentHealth == 3"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">重病</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.parentHealth == 4"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">去世(父母任意一位或同时)</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>外出工作情况</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.workOut == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">在本城市工作</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.workOut == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">外出工作</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>父母关系是否融洽</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="
                      checkedRecord.interviewReport.parentsRelHarmonious == 1
                    "
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">是</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="
                      checkedRecord.interviewReport.parentsRelHarmonious == 0
                    "
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">否</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>父母教育方式</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.parentEdu == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">温和</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.parentEdu == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">粗暴</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>父母婚姻状况</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.maritalStatus == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">良好</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.maritalStatus == 3"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">没离异但各自在异地</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.maritalStatus == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">离异</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>家庭经济情况</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.familyEconomic == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">富裕</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.familyEconomic == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">小康</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.familyEconomic == 3"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">普通</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.familyEconomic == 4"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">贫困</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>是否养小动物，如猫和狗</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.havePets == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">是</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.havePets == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">否</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td rowspan="2">实际监护人</td>
            <td align="left" class="set-padding">
              姓名：{{ checkedRecord.interviewReport.guardianName }}
            </td>
            <td colspan="2" align="left" class="set-padding">
              联系方式：{{ checkedRecord.interviewReport.guardianContact }}
            </td>
          </tr>
          <tr align="left">
            <td colspan="3" class="set-padding">
              与当事人关系：{{
                getGuardianName(checkedRecord.interviewReport.relStudent)
              }}
            </td>
          </tr>
          <tr>
            <td rowspan="13">个人状态</td>
            <td>学习成绩</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.achievementLevel == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">优</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.achievementLevel == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">良</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.achievementLevel == 3"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">中</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.achievementLevel == 4"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">及格</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.achievementLevel == 5"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">差</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>学习压力</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.studyPressure == 5"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">压力很小</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.studyPressure == 4"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">压力偏小</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.studyPressure == 3"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">一般</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.studyPressure == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">压力偏大</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.studyPressure == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">压力很大</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>是否抽烟</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.smoking == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">是</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.smoking == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">否</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>是否喝酒</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.drinking == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">是</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.drinking == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">否</span>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>是否恋爱</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.love == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">是</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.love == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">否</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>是否霸凌他人</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.bullying_others == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">是</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.bullyingOthers == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">否</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>是否被他人霸凌</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.bullied == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">是</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.bullied == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">否</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>同学关系</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.classmateRel == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">紧密</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.classmateRel == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">普通</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.classmateRel == 3"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">疏离</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.classmateRel == 4"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">冷漠</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>师生关系</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.teaStuRel == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">和谐</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.teaStuRel == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">不和谐</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>是否有网瘾</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.internetAddiction == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">是</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.internetAddiction == 0"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">否</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>上网通常做些什么</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.doOnline == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">学习</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.doOnline == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">听音乐</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.doOnline == 3"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">玩游戏</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.doOnline == 4"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">聊天</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.doOnline == 5"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">其他</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>兴趣爱好</td>
            <td colspan="3" align="left" class="set-padding">
              <div class="flex">
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.hobby == 1"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">看书</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.hobby == 2"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">运动类</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.hobby == 3"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">文艺活动</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.hobby == 4"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">手工类</span>
                </div>
                <div class="check-box">
                  <i
                    class="el-icon-success check-icon"
                    v-if="checkedRecord.interviewReport.hobby == 5"
                  ></i>
                  <span class="check-icon no-checked" v-else></span>
                  <span class="check-text">其他</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>是否有躯体症状</td>
            <td colspan="3" align="left" class="set-padding">
              <span
                v-if="
                  checkedRecord.interviewReport.bodySymptom != '0' &&
                  checkedRecord.interviewReport.bodySymptom != '1'
                "
                >{{ checkedRecord.interviewReport.bodySymptom }}</span
              >
            </td>
          </tr>
          <!-- 抑郁情况 -->
          <tr align="left" v-if="checkedRecord.interviewReport.type != 3">
            <td colspan="5" class="set-padding">
              <span v-if="checkedRecord.interviewReport.type == 1"
                >抑郁情况分析：</span
              >
              <span v-if="checkedRecord.interviewReport.type == 2"
                >焦虑情况分析：</span
              >
            </td>
          </tr>
          <tr align="left" v-if="checkedRecord.interviewReport.type != 3">
            <td colspan="5">
              <div style="min-height: 100px" v-if="depressedArr.length">
                <div
                  v-for="(item, index) in depressedArr"
                  :key="index"
                  :id="item.id"
                  :style="'width:100%;height:300px;'"
                ></div>
              </div>
            </td>
          </tr>
          <!-- 评语 -->
          <tr align="left">
            <td colspan="5" class="set-padding">结论：</td>
          </tr>
          <tr align="left">
            <td colspan="5">
              <div style="min-height: 50px" class="depressed_suggestion">
                <p>
                  【基本情况】： {{ checkedRecord.interviewReport.conclusion }}
                </p>
                <p v-if="checkedRecord.interviewReport.type != 3">
                  【{{
                    checkedRecord.interviewReport.type == 1 ? "抑郁" : "焦虑"
                  }}情况】：
                  <span
                    v-for="(item, index) in depressedObj.conclusion"
                    :key="index"
                  >
                    {{ item }};
                  </span>
                </p>
              </div>
            </td>
          </tr>

          <!--严重程度-->
          <tr align="left">
            <td colspan="5" class="set-padding">
              严重程度：{{
                $LYCom.GetDegreeName(checkedRecord.interviewReport.degree)
              }}
            </td>
          </tr>
          <!-- 结语 -->
          <tr align="left">
            <td colspan="5" class="set-padding">辅导记录及建议：</td>
          </tr>
          <tr align="left">
            <td colspan="5" class="set-padding">
              <p class="conclusion_text">
                {{ checkedRecord.interviewReport.epilogue }}
              </p>
            </td>
          </tr>
        </table>
        <div class="create_user_name" v-if="checkedRecord">
          <div class="teacher-style" style="margin: 5px 0">
            <span>心理老师</span>：{{
              checkedRecord.interviewReport.createUserName
                ? checkedRecord.interviewReport.createUserName
                : checkedRecord.create_user_name
            }}
          </div>
          <div class="teacher-style">
            {{
              new Date(
                checkedRecord.interviewReport.createTime
                  ? checkedRecord.interviewReport.createTime
                  : checkedRecord.create_time
              ).format("yyyy-MM-dd hh:mm:ss")
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  data() {
    return {
      depressedArr: [], //抑郁配置项
      anxiousArr: [], // 焦虑配置项
      depressedObj: {
        suggestion: [],
        conclusion: [],
      },
      relatives: [
        {
          //与监护人关系
          value: 1,
          label: "父母",
        },
        {
          value: 2,
          label: "爷爷",
        },
        {
          value: 3,
          label: "奶奶",
        },
        {
          value: 4,
          label: "外公",
        },
        {
          value: 5,
          label: "外婆",
        },
        {
          value: 6,
          label: "其他",
        },
      ],
    };
  },
  props: {
    psychoRecordId: 0, // 访谈id
    checkedRecord: {
      default: null,
    },
    // 角色身份：1：学生 2：校外人员
    type: {
      default: 1,
    },
  },
  watch: {
    //监checkedRecord状态发生变化
    checkedRecord: {
      //深度监听
      deep: true,
      //立即监听
      immediate: true,
      //监听到carouselList状态发生变化了
      handler(val) {
        console.log(val);

        if (this.psychoRecordId) {
          this.getInterviewEcharts2(); // 通过访谈记录获取图形
        } else {
          if (val && val.interviewReport && val.interviewReport.type != 3) {
            this.getInterviewEcharts(); // 通过任务获取访谈记录图形配置
          }
        }
      },
    },
  },
  methods: {
    // 通过访谈记录编号获取图形配置
    getInterviewEcharts2() {
      this.$request
        .get("/educationadmin/taskInfo/getReportByPsychoRecordId", {
          params: {
            psychoRecordId: this.psychoRecordId,
          },
        })
        .then((res) => {
          if (res) {
            this.coachReport = res;
            this.initData(); // 图形渲染
          } else {
            this.coachReport = null;
          }
        });
    },
    // 通过测评报告获取访谈记录图形配置
    getInterviewEcharts() {
      this.$request
        .get("/educationadmin/taskInfo/getReportByTaskId", {
          params: {
            taskId: this.checkedRecord.interviewReport.taskId,
            type: this.type, // 1.学生 2.教师3.校外人员
            personId:
              this.type == 1
                ? this.checkedRecord.interviewReport.studentId
                : this.type == 2
                ? this.checkedRecord.interviewReport.teacherId
                : this.checkedRecord.interviewReport.registerId, // 学生id  校外人员id  教师id
          },
        })
        .then((res) => {
          if (res) {
            this.coachReport = res;
            this.initData(); // 图形渲染
          } else {
            this.coachReport = null;
          }
        });
      // .catch(() => {
      //   this.$message.error("获取访谈图形配置错误!!!");
      // });
    },
    // 初始化数据
    initData() {
      // 组织图形配置
      let depressedConfig; // 抑郁图形配置数据
      this.depressedArr = [];
      if (
        this.coachReport &&
        this.coachReport.chartConfigList &&
        this.coachReport.chartConfigList.length > 0
      ) {
        depressedConfig = this.coachReport.chartConfigList;
        // 抑郁结论/建议
        if (this.coachReport && this.coachReport.mmptResultList.length > 0) {
          this.coachReport.mmptResultList.forEach((item) => {
            if (
              item.conclusion &&
              this.depressedObj.conclusion.indexOf(item.conclusion) == -1
            ) {
              this.depressedObj.conclusion.push(item.conclusion);
            }
            if (
              item.suggestion &&
              this.depressedObj.suggestion.indexOf(item.suggestion) == -1
            ) {
              this.depressedObj.suggestion.push(item.suggestion);
            }
          });
        }
        // 初始化报告
        this.convertgaugeData(depressedConfig[0], 0, this.coachReport);
      }
    },
    // 仪表盘
    convertgaugeData(data, index, tempdata) {
      var between = JSON.parse(data.rangeDescription);
      var max = 0,
        min = 0;
      var detail = {};
      if (between) {
        if (between.color && between.color.length > 0) {
          between.color.forEach((item) => {
            if (item.max >= max) {
              max = item.max;
            }
            if (item.min <= min) {
              min = item.min;
            }
          });
        }
        if (between.detail) {
          detail = between.detail;
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        tooltip: {
          formatter: "{a} <br/>{b} : {c}分",
        },
        title: {
          text: "总分",
          bottom: "15%",
          left: "center",
        },
        series: [],
      };
      var tempData = [];
      data.items.forEach((item1) => {
        tempData.push({
          value: item1.score,
        });
      });

      var colorArea = this.getColorArea(data.rangeDescription);
      options.series.push({
        type: "gauge",
        name: data.title,
        axisLine: {
          lineStyle: {
            color: colorArea,
          },
        },
        detail: detail,
        min: min,
        max: max,
        data: tempData,
      });
      this.depressedArr.push(options);
      setTimeout(() => {
        let chartDom = document.getElementById(options.id);
        if (chartDom) {
          let chart = echarts.init(chartDom);
          this.$nextTick(() => {
            chart.setOption(options);
          });
        }
      }, 500);
    },
    // 获取颜色
    getColorArea(data) {
      var realdata = JSON.parse(data);
      var max = 0,
        min = 0;
      if (realdata && realdata.color) {
        var result = [];
        realdata.color.forEach((m) => {
          if (m.max > max) {
            max = m.max;
          }
          if (m.min < min) {
            min = m.min;
          }
        });
        realdata.color.forEach((m) => {
          var arr = [];
          var value = (m.max / max).toFixed(1);
          arr.push(value);
          arr.push(m.color);
          result.push(arr);
        });

        return result;
      } else {
        return [
          [0.2, "#91c7ae"],
          [0.8, "#63869e"],
          [1, "#c23531"],
        ];
      }
    },
    /* 监护人姓名 */
    getGuardianName(val) {
      if (!val) {
        return "";
      } else {
        var laber = this.relatives.find((x) => x.value == val);
        return laber.label;
      }
    },
  },
};
</script>

<style scoped>
.student-show {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0px;
  border: 1px solid black;
  font-size: 16px;
  font-weight: 400;
  font-family: "微软雅黑 Regular";
  text-align: center;
}

.student-show td {
  border: 1px solid black;
  height: 35px;
}

.student-show tr {
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  font-family: "微软雅黑 Regular";
}

.student-show .el-radio__label {
  font-size: 16px;
}

.table-header {
  font-weight: 600 !important;
}

.create_user_name {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.teacher-style {
  font-size: 16px;
  text-align: right;
}

.set-padding {
  padding-left: 10px;
}

.conclusion_text {
  min-height: 50px;
  padding: 10px;
}

.depressed_suggestion {
  padding: 10px;
  line-height: 30px;
}
.check-box {
  margin-right: 20px;
  display: flex;
  align-items: center;
}
.check-box .check-icon {
  display: inline-block;
  width: 20px;
  margin-right: 5px;
}
.check-box .check-text {
  font-size: 16px;
  display: inline-block;
}
.check-box .el-icon-success {
  color: #091d7c;
  font-size: 20px;
}
.check-box .no-checked {
  width: 14px !important;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #ddd;
}
.check-box .noChecked {
  width: 14px !important;
  height: 14px;
  border-radius: 2px;
  border: 1px solid #ddd;
}
.check-box .isChecked {
  width: 14px !important;
  height: 14px;
}
.questBox {
  flex-wrap: wrap;
  padding: 5px;
}
.questBox .check-box {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/detailCoach.vue